"use client";

import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const features = [{
  number: "01",
  category: "TECNOLOGIA",
  title: "Produção de Pasta",
  body: "Otimize cada etapa do seu processo com soluções para supressão de poeiras, limpeza de tanques, condicionamento de gases, recuperação de licor negro e muito mais.",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-15.09.59.png?v=cfeupmv4lg",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-15.09.59.png?v=237k6eavd06-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-15.09.59.png?v=bjp0dtjbs5o-wvc-sizes",
  alt: "Bicos anti-entupimento de alta precisão em operação em linha de fabrico de papel"
}, {
  number: "02",
  category: "SUSTENTABILIDADE",
  title: "Papel & Embalagens",
  body: "Previna o entupimento de bicos e mantenha a sua fábrica a funcionar de forma eficiente com a nossa linha completa de showers, bicos de refilo e soluções de revestimento.",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-15.07.02-1.png?v=y76ahuxqjia",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-15.07.02-1.png?v=smopc2wu009-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-15.07.02-1.png?v=hkgrax87g39-wvc-sizes",
  alt: "Sistema otimizado de lavagem e pulverização em fábrica de pasta e papel"
}, {
  number: "03",
  category: "AUTOMAÇÃO",
  title: "Fabrico de Tissue",
  body: "Melhore as suas operações de produção de tissue com tecnologia de pulverização para showers, revestimento e refilo.",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-15.06.46.png?v=bbb8dd3b5ep",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-15.06.46.png?v=cc2jj8yrgy8-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-15.06.46.png?v=sv54201tt-wvc-sizes",
  alt: "Equipamento automatizado de revestimento e pulverização uniforme em folha de papel"
}];
export default function Casestudydeepdive() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".vlt-eyebrow", {
        opacity: 0,
        y: 16
      });
      gsap.set(".vlt-heading", {
        opacity: 0,
        y: 24
      });
      gsap.to(".vlt-eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".vlt-header",
          start: "top 85%",
          once: true
        }
      });
      gsap.to(".vlt-heading", {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: "power3.out",
        delay: 0.08,
        scrollTrigger: {
          trigger: ".vlt-header",
          start: "top 85%",
          once: true
        }
      });
      const cards = gsap.utils.toArray<HTMLElement>(".vlt-card");
      gsap.set(cards, {
        opacity: 0,
        y: 32
      });
      gsap.to(cards, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power3.out",
        stagger: 0.15,
        scrollTrigger: {
          trigger: ".vlt-grid",
          start: "top 80%",
          once: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".vlt-eyebrow", ".vlt-heading", ".vlt-card"], {
        opacity: 1,
        y: 0,
        scale: 1
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="31429" id="casestudydeepdive" className="bg-background text-foreground py-24 md:py-36 relative overflow-hidden">
      <div ref={container} className="mx-auto max-w-[1360px] px-5 md:px-8 lg:px-14">
        {/* Header */}
        <div className="vlt-header mx-auto max-w-3xl text-center mb-16 md:mb-20">
          <div className="vlt-eyebrow inline-block text-xs font-medium uppercase mb-4" style={{
          letterSpacing: "0.22em",
          color: "var(--muted-foreground)"
        }}>As fábricas de papel, embalagem e tissue recorrem à Spraying Systems Co. para tecnologia que otimiza as operações de pulverização ao longo de todo o processo de fabrico. Oferecemos mais produtos para esta indústria do que qualquer outro fornecedor, desde bicos anti-entupimento até sistemas automatizados completos, todos concebidos para o ajudar a reduzir o consumo de água, os tempos de paragem e o desperdício, melhorando simultaneamente a qualidade e a eficiência.</div>
          <h2 className="vlt-heading font-default font-semibold text-[clamp(2rem,4vw,3.25rem)] leading-tight" style={{
          letterSpacing: "-0.02em",
          color: "var(--foreground)"
        }}>PASTA, PAPEL & TISSUE</h2>
        </div>

        {/* 3-Column Cards Grid */}
        <div className="vlt-grid grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((f, i) => <div key={f.number} data-index={i} className="vlt-card bg-card border border-border rounded-3xl p-6 md:p-7 shadow-xs transition-all duration-300 hover:shadow-md hover:-translate-y-1 flex flex-col justify-between">
              <div>
                {/* Image ~3:2 ratio */}
                <div className="relative aspect-[3/2] w-full overflow-hidden rounded-xl bg-muted mb-6">
                  <img src={f.image} data-wvc-srcset={f.srcset} data-wvc-sizes={f.sizes} alt={f.alt} loading="lazy" decoding="async" className="w-full h-full object-cover" />
                </div>

                {/* Eyebrow */}
                <div className="text-xs font-semibold tracking-wider text-muted-foreground uppercase mb-2">
                  {f.number} — {f.category}
                </div>

                {/* Title */}
                <h3 className="text-xl md:text-2xl font-bold text-foreground mb-3 leading-snug">
                  {f.title}
                </h3>

                {/* Body */}
                <p className="text-muted-foreground text-sm md:text-base leading-relaxed">
                  {f.body}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}